<template>
<v-container>
<!--(팝업)전체 기업 목록-->
 <v-dialog
      v-model="unapprovedOrgViewVisble" @keydown.esc="unapprovedOrgViewVisble = false"
      max-width="800px"
      persistent>
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          기업 참여 요청 현황
          <v-btn fab class="popBtnClose" @click="unapprovedOrgViewVisble = false"></v-btn>
        </v-card-title>
        <!--/팝업 제목-->
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
              <!--리스트-->
            <v-row class="align-center pop_list_carD02H100">
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
              <!--반복: 리스트 카드-->
              <v-card class="list_carD02_con" v-for="(orglist, index) of unapprovedOrgs"  :key="index"  @click="dialogIdtest = true">
                <!-- 결재상태가 결재요청이면서 본인이 보낸 결재건이면 체크박스 숨김처리 -->
                <v-list-item class="carD_box_delO">                  
                  <div class="org_pic_s cpn mr-1">
                    <v-img :src="unapprovedOrgimgs[index]" style="height: 100%; border-radius: 15px;"></v-img>
                  </div>
                    <ul class="list_carD02_ulTxtBox">
                      <li class="txtCon01_02"><!--줄어들면 .. 처리, .. 처리시 마우스 오버하면 텍스트 보이게 처리-->
                        <span class="txt_txt01">{{ orglist.organizationName }}</span>
                        <span class="txt_txt02">{{ orglist.organizationRegistrationNumber|regNumFilter }}</span>
                      </li>
                      <li class="txtCon02_02"><!--줄어들면 .. 처리, .. 처리시 마우스 오버하면 텍스트 보이게 처리-->
                        <span class="txt_tt">요청일</span>
                        <span class="txt_txt02">{{ orglist.creationDatetime | formatDate }}</span>
                      </li>
                      <li class="txtCon01_02"><!--줄어들면 .. 처리, .. 처리시 마우스 오버하면 텍스트 보이게 처리-->
                        <span class="txt_txt01">기업참여 요청중</span>
                      </li>
                    </ul>
                  </v-list-item>
              </v-card>
              <!--리스트 카드-->
              </v-col>
            </v-row>
            <!--/리스트-->
          </v-row>
        </v-card-text>
        <!--/팝업 내용-->
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn text @click="unapprovedOrgViewVisble = false">닫기</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
    <s-loading ref="loading"></s-loading>
    <s-confirm ref="confirm"></s-confirm>
    <!--/(팝업)전체 기업 목록--> 
</v-container>
</template>

<script>
import moment from 'moment'

export default {
    name: 'comList',
    components: {
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('YYYY-MM-DD HH:mm')
        }
      },
      regNumFilter: function (value) {
        if (value) {
          return String(value).replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3')
        }
      }
    },
    props:{
      unapprovedOrg: [],
      unapprovedOrgimg: []
    },
    data () {
        return {
            unapprovedOrgViewVisble : false,
            unapprovedOrgs: [],
            unapprovedOrgimgs: []
        }
    },
    created () {
    },
    mounted () {
    },  
    methods: {
        open () {
          this.unapprovedOrgs = this.unapprovedOrg
          this.unapprovedOrgimgs = this.unapprovedOrgimg
          this.unapprovedOrgViewVisble = true
        }
    }
}
</script>